/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeValueInArray } from 'utils/functions';
import OfferFoldersListComponent from './OfferFoldersListComponent';
import { selectFolder } from 'actions/actionCreators/offer/offerActions';
import { resetFolderList } from 'actions/actionCreators/offer/offerStatesActions';

export const OfferFoldersContainer = ({ offerHeader, onHandleShowFoldersModal, actions }) => {
  const [localFolderList, setLocalFolderList] = useState([]);

  const closeFoldersModal = () => {
    onHandleShowFoldersModal(false);
    actions.resetFolderList();
  };

  const onSaveFolder = () => {
    let selectedFolder = localFolderList.filter(function (item) {
      return item.selected === true;
    });
    actions.selectFolder(offerHeader.documentId, offerHeader.siteId, selectedFolder[0].folderId, selectedFolder[0].folderSiteId);
    onHandleShowFoldersModal(false);
  };

  useEffect(() => {
    setLocalFolderList(offerHeader.folderList);
  }, []);

  const onRowSelectionChanged = (folderId, checked) => {
    let listWithSelection = changeValueInArray(localFolderList, 'folderId', folderId, 'selected', checked);
    setLocalFolderList(listWithSelection);
    localFolderList.forEach(function (item) {
      let computedList = changeValueInArray(
        listWithSelection,
        'folderId',
        item.folderId,
        'selected',
        folderId === item.folderId && checked
      );
      setLocalFolderList(computedList);
      listWithSelection = computedList;
    });
  };

  return (
    <OfferFoldersListComponent
      onRowSelectionChanged={onRowSelectionChanged}
      folderList={localFolderList}
      closeFoldersModal={closeFoldersModal}
      onSaveFolder={onSaveFolder}
      showModal={onHandleShowFoldersModal}
    />
  );
};

OfferFoldersContainer.propTypes = {
  offerHeader: PropTypes.object,
  onHandleShowFoldersModal: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  selectFolder: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    offerHeader: state.currentOffer.header
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ selectFolder, resetFolderList }, dispatch),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(OfferFoldersContainer);
